import { BUSCAR_VEICULOS_DISPONIVEIS, LIMPAR_VEICULOS_DISPONIVEIS } from '../../actions/types'

const initialState = undefined;

export default function reducerVeiculosDisponiveis (state = [], action = initialState) {
  switch (action.type) {
    case BUSCAR_VEICULOS_DISPONIVEIS: {
      const veiculos = action.payload.data;

      if (veiculos) {
        return veiculos
      }
      return []
    }

    case LIMPAR_VEICULOS_DISPONIVEIS:
      return [];

    default: {
      return state
    }
  }
}
